import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

import MainPagetitle from '../../layouts/MainPagetitle';
import { Modal, Button } from 'react-bootstrap';
import BrandService from '../../api/services/BrandService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const EditBrand = () => {
  var imageUrl = process.env.REACT_APP_LARAVEL_BRAND_IMAGE_URL;
  const params = useParams();
  const [error, setError] = useState("")
  const [brandModal, setBrandModal] = useState(false);
  const [brand, setBrand] = useState([]);
  const [file, setFile] = useState()
  const [isLoading, setisloading] = useState(true);
  useEffect(() => {
    var id = params.id;
    getbrandByID(id);
  }, []);

  const getbrandByID = async (id) => {
    try {
      let brand = await BrandService.show(id).json();
      setBrand(brand.data);
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var logo = fileReader.result
      setFile(logo)
      // console.log(logo)
    }
  }
  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title":event.target.de_title.value,
        //"logo":file ? file.split(',')[1] : "",
        "logo": ""
      }
      let responseData = await BrandService.update(params.id, userData).json()
      if (responseData.status === true) {
        setBrandModal(true)
      }
    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Brand" pageTitle={'Brand'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Brand</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmitForm}>
                  <div className="row">
                    {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username"
                        defaultValue={
                          brand.title
                            ? brand.title
                            : ''
                        } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder=""  defaultValue={
                          brand.de_title
                            ? brand.de_title
                            : ''
                        }/>
                    </div>
                    {/* <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-number" className="form-label">Logo <span className="text-danger">*</span></label>
                                            {brand.logo ? <img className="img-drop-area" height={100} width={100}  name="logo" src={file ? file: imageUrl+ brand.logo} alt='' /> :null}
                                            <input type="file" className="form-control" name='logo' accept="image/png, image/jpeg"  onChange={onFileChange}  />
                                        </div>	 */}
                  </div>
                  <h5 style={{ color: 'red' }}>{error}</h5>
                  <div>
                    <button type="submit" className="btn btn-primary mb-2 me-1"  >Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <LogoAnimationLoader />}
      <Modal centered className="mark-attendence" show={brandModal}>
        <Modal.Header>
          <Modal.Title>Update </Modal.Title>
          <Button variant="" className="btn-close" onClick={() => setBrandModal(false)}></Button>
        </Modal.Header>
        <Modal.Body>Update Service Successfully!!!.</Modal.Body>
        <Modal.Footer>
          <Link className="btn btn-primary" to={'/admin/brand'} variant="danger light" onClick={() => setBrandModal(false)}>Close</Link>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditBrand;